:host {
  display: block;
}

.anchor-c-help-box {
  display: flex;
  align-items: left;
  padding: var(--p-size-static-300);
  border-radius: var(--p-size-static-100);
  background-color: var(--b-color-supportive-light);
  color: var(--s-color-text-default);
  font-size: var(--s-size-text-default);
  line-height: var(--s-size-line-height-paragraph);
  text-align: left;

  &__content {
    max-width: 75ch;
    flex-direction: column;
  }

  &__close-icon {
    cursor: pointer;
    margin-left: auto;
  }

  ::slotted(*) {
    display: flex;
    line-height: var(--s-size-line-height-paragraph);
  }

  ::slotted([slot|='icon']) {
    line-height: 2;
  }

  ::slotted([slot|='header']) {
    margin-top: var(--p-size-static-200);
    font-weight: var(--s-font-weight-heading-emphasized);
  }

  ::slotted([slot|='link']) {
    width: fit-content;
    margin-top: var(--p-size-static-300);
    color: var(--s-color-text-default);
  }
  ::slotted([slot|='link']:focus) {
    border-radius: var(--p-size-static-025);
    outline: var(--s-size-outline-focus-ring-width) var(--s-color-outline-focus-ring) solid;
    outline-offset: var(--p-size-static-0125);
  }
}
